// App.js

import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DashboardPage from './components/Admin_Side/Dashboard/DashboardPage.js';
import Add_Customer_Page from './components/Admin_Side/Add_Customer/Add_Customer_Page';
import Add_Contract_Page from "./components/Admin_Side/Add_Contract/Add_Contract.js";
import Add_Admin from './components/Admin_Side/Add_Admin/Add_Admin.js';
import Add_User from './components/Admin_Side/Add_User.js';
import View_Edit_Contract_Page from './components/Admin_Side/Edit_Contract/View_Edit_Contract.js';
import LoginPage from './components/Login/Login_Page.js';
import CustomerDashboardPage from './components/Customer_Side/Customer_Dashboard/DashboardPage.js';
import EditProfilePage from './components/Customer_Side/Edit_Password/Edit_Profile.js';
import View_Contract from './components/Customer_Side/View_Contract/View_Contract.js';
import ViewUsers from './components/View_Users.js';
import SummaryTable from './components/Admin_Side/Dashboard/TableSummary.js';
import View_Edit_Customer_Page from './components/Admin_Side/Company_Profile/View_Edit_Customer.js';
import Add_Customer_Admin from './components/Admin_Side/Add_Customer/Add_Customer_Page';
import AddViewerForm from './components/Admin_Side/User_Managment/Add_Customer_Viewer.js';
import View_Customer_Viewer from './components/Admin_Side/User_Managment/View_Customer_Viewer.js';
import EditCustomerPage from './components/Admin_Side/Company_Profile/Edit_Customer.js';
import EditContract from './components/Admin_Side/Edit_Contract/Edit_Contract.js';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/add_customer" element={<Add_Customer_Page />} />
        <Route path="/add_contract" element={<Add_Contract_Page />} />
        <Route path="/add_admin" element={<Add_Admin />} />
        <Route path="/add_user" element={<Add_User />} />
        <Route path="/view_edit_contract" element={<View_Edit_Contract_Page />} />
        <Route path="/customer_dashboard" element={<CustomerDashboardPage />} />
        <Route path="/edit_profile" element={<EditProfilePage />} />
        <Route path="/view_contract" element={<View_Contract />} />
        <Route path="/view_users" element={<ViewUsers />} />
        <Route path="/report" element={<SummaryTable />} />
        <Route path="/view_edit_customer" element={<View_Edit_Customer_Page />} />
        <Route path="/add_customer_admin" element={<Add_Customer_Admin />} />
        <Route path="/add_viewer" element={<AddViewerForm />} />
        <Route path="/view_customer_viewer" element={<View_Customer_Viewer />} />
        <Route path="/edit_customer" element={<EditCustomerPage />} />
        <Route path="/edit_contract" element={<EditContract />} />
      </Routes>
    </Router>
  );
}

export default App;



